import { AfterViewInit, Component, ElementRef, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { RouterLink } from '@angular/router';

import { UI } from 'src/app/components/ui';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-landing-home',
  standalone: true,
  imports: [RouterLink, ...UI],
  templateUrl: './landing-home.component.html',
  styleUrl: './landing-home.component.scss',
})
export class LandingHomeComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('revealItem') revealItems!: QueryList<ElementRef<HTMLElement>>;

  private observer: IntersectionObserver | null = null;

  constructor(public readonly auth: AuthService) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('revealed');
          this.observer?.unobserve(entry.target);
        }
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    for (const item of this.revealItems.toArray()) {
      this.observer.observe(item.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
